/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/WorkflowDrawer.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Master
 *
 * PURPOSE:
 * Workflow Create / Edit Dialog
 *
 * ARCHITECTURE
 * - Bootstrap/AdminLTE
 * - Stateless Component
 * - Hosts WorkflowForm
 * - No Business Logic
 ******************************************************************************/

import React from "react";

import WorkflowForm from "./WorkflowForm";

export default function WorkflowDrawer({

    open,

    mode = "create",

    workflow = null,

    formData,

    errors = {},

    loading = false,

    saving = false,

    workflowTypes = [],

    departments = [],

    onChange,

    onClose,

    onSubmit,

}) 

{

    if (!open) {

        return null;

    }

    const title =
        mode === "edit"
            ? "Edit Workflow"
            : "Create Workflow";

    return (

        <div
            className="modal fade show"
            style={{
                display: "block",
                backgroundColor: "rgba(0,0,0,0.50)",
            }}
        >

            <div
                className="modal-dialog modal-xl modal-dialog-scrollable"
            >

                <div className="modal-content">

                    {/* ------------------------------------------------ */}
                    {/* HEADER */}
                    {/* ------------------------------------------------ */}

                    <div className="modal-header">

                        <h5 className="modal-title">

                            {title}

                        </h5>

                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        />

                    </div>

                    {/* ------------------------------------------------ */}
                    {/* BODY */}
                    {/* ------------------------------------------------ */}

                    <div className="modal-body">

                        <WorkflowForm

                        formData={formData}

                        errors={errors}

                        loading={loading}

                        saving={saving}

                        workflowTypes={workflowTypes}

                        departments={departments}

                        onChange={onChange}

                        onSubmit={onSubmit}

                        onCancel={onClose}

                    />

                    </div>

                </div>

            </div>

        </div>

    );

}